import { useState, useEffect, useContext } from "react";
import {
  Box,
  Grid,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TableContainer,
  Typography,
} from "@mui/material";
import { useQuery } from "@apollo/client";
//Import from project
import "../../Style/pagestyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { GET_COURSE_PAGINATION } from "../../Schema/Course";
import {
  PageHeaderTitle,
  SearchTextField,
  ButtonCreate,
} from "../../Utils/Component";
import EmptyData from "../../Components/Include/EmptyData/EmptyData";
import CourseForm from "../../Components/Course/CourseForm";
import LoadingPage from "../../Utils/LoadingPage";
import CourseAction from "../../Components/Course/CourseAction";
import FooterPagination from "../../Utils/FooterPagination";
import useWithDimension from "../../Hooks/useWithDimension";

export default function Course() {
  // Change Language
  const { t } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const { width } = useWithDimension();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState("");
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState();

  let pageStudent = window.localStorage.getItem("pageStudent");

  const { refetch } = useQuery(GET_COURSE_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      keyword: keyword,
      pagination: true,
    },
    onCompleted: ({ getCoursePagination }) => {
      setTableData(getCoursePagination?.data);
      setPaginationData(getCoursePagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  const handleSearch = (e) => {
    setPage(1);
    setKeyword(e.target.value);
  };

  useEffect(() => {
    refetch();
  }, [page, open, keyword]);

  useEffect(() => {
    setPage(parseInt(pageStudent || 1));
  }, [pageStudent]);

  const StudentSelectId = window.localStorage.getItem("ClickStudentId");

  return (
    <div className="page-container">
      <PageHeaderTitle
        classPage={t("class-page-title")}
        classSlash="slash-title"
        routeTo={"/setting"}
        pageTitle={t("page_setting")}
        detailTitle={t("page_course")}
      />

      <Box sx={{ marginTop: "20px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("search")}
            </Typography>
            <SearchTextField
              className={"text-field"}
              handleSearch={handleSearch}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={8} lg={9} xl={10}>
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn={"btn-create"}
              classIcon={"icon-add"}
            />

            {open && (
              <CourseForm
                open={open}
                setRefetch={refetch}
                dialogTitle={"Create"}
                handleClose={handleClose}
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table">
            <TableHead className="header-row">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width="10%"
                >
                  {t("thead_no")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="20%">
                  {t("thead_khmer_name")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="20%">
                  {t("thead_english_name")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="20%">
                  {t("thead_total_hour")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="25%">
                  {t("thead_remark")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title-end")}
                  width="5%"
                ></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={10} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 || tableData?.length === undefined ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={10} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      return (
                        <TableRow
                          className={
                            StudentSelectId === row._id
                              ? "body-row onclick-student"
                              : "body-row"
                          }
                          key={index}
                        >
                          <TableCell className="body-cell-start">
                            {index + paginationData?.slNo}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.khName}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.enName}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.totalHour} {t("thead_hour")}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.remark}
                          </TableCell>
                          <TableCell className="body-cell-end" align="right">
                            <CourseAction editData={row} setRefetch={refetch} />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
          Type="student"
        />
      </Box>
    </div>
  );
}
